export const NON_RECOVERABLE_ERROR_MAPPINGS = {
  '400.6666.4050': {
    isRecoverable: false,
    title: '',
    CTA: '',
    errorMsg: '',
    hasSystemErrorIssue: true
  },
  '400.1100.2291': {
    isRecoverable: false,
    title: "Our system isn't cooperating.",
    CTA: 'Try again',
    errorMsg: "We're having some technical difficulties. Please try again.",
    hasSystemErrorIssue: true
  },
  '400.1100.2290': {
    isRecoverable: false,
    title: '',
    CTA: '',
    errorMsg: '',
    hasSystemErrorIssue: true
  },
  '409.1100.2269': {
    isRecoverable: true,
    title: "Our system isn't cooperating.",
    CTA: 'Try again',
    errorMsg: "We're having some technical difficulties. Please try again.",
    hasSystemErrorIssue: true
  }
}
export default NON_RECOVERABLE_ERROR_MAPPINGS
